import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-5 pt-24 text-center">
      <p className="mono-label text-xs text-[var(--crtr-yellow)]">404))</p>
      <h1 className="font-display mt-4 text-5xl text-white sm:text-6xl lg:text-7xl">SEITE NICHT GEFUNDEN.</h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-white/70">
        Diese Seite existiert nicht (mehr). Zurück zu den Menschen, Marken und Ideen mit echtem Potenzial.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[var(--crtr-yellow)] py-3 pl-5 pr-6"
      >
        <ArrowLeft className="h-4 w-4 text-black transition-transform group-hover:-translate-x-0.5" />
        <span className="mono-label text-xs text-black">ZUR STARTSEITE</span>
      </Link>
    </section>
  );
}
